import { useMemo } from 'react'
import { MUTUAL_FUND_DETAIL_IMAGE_URL } from '../../constants'
import { useMetaDataContext } from '../../state-management/contexts/MetaDataContext'
import { WaterfallSections } from '../../types/mutual-fund-detail.types'

type ConfigDatum = {
  sectionTitle: string
  imgSrc: string
}

type UnavailableBannerConfig = {
  rollingReturns: ConfigDatum
  elite: ConfigDatum
  hero: ConfigDatum
}

const unavailableBannerConfig: UnavailableBannerConfig = {
  [WaterfallSections.ROLLING_RETURNS]: {
    sectionTitle: 'Rolling Returns',
    imgSrc: '/rolling-returns-unavailable-banner.svg'
  },
  [WaterfallSections.HERO]: {
    sectionTitle: 'Fund Performance',
    imgSrc: '/power-performance-unavailable-banner.svg'
  },
  [WaterfallSections.ELITE]: {
    sectionTitle: 'Elite insights',
    imgSrc: '/elite-unavailable-banner.svg'
  }
}

export default function UnavailableSectionsBanner() {
  const { data: metadata } = useMetaDataContext()

  const unavailableSections = useMemo(() => {
    const unavailableKeys = Object.keys(metadata?.sectionAvailability ?? {})?.filter(
      (key) => (metadata?.sectionAvailability as any)?.[key] === 'NO'
    )
    return Object.entries(unavailableBannerConfig)
      ?.filter(([key]) => unavailableKeys?.includes(key))
      ?.map(([, config]) => config)
  }, [metadata])

  if (unavailableSections?.length === 0) return null

  const sectionsText = useMemo(() => {
    const sectionTitles = unavailableSections?.map(({ sectionTitle }) => sectionTitle)
    return unavailableSections?.length === 1
      ? `${sectionTitles?.[0]} is`
      : `${sectionTitles?.slice(0, -1).join(', ')} and ${sectionTitles?.[unavailableSections?.length - 1]} are`
  }, [unavailableSections])

  if (unavailableSections?.length > 0)
    return (
      <div className='rounded-[12px] bg-white flex flex-col gap-4 px-4 pt-4 pb-5'>
        <div className='flex items-center z-0'>
          {unavailableSections?.map(({ imgSrc }, index) => (
            <div
              key={imgSrc}
              style={{ zIndex: unavailableSections?.length - index }}
              className={index === 0 ? '-ml-1' : '-ml-3'}
            >
              <img src={`${MUTUAL_FUND_DETAIL_IMAGE_URL}${imgSrc}`} />
            </div>
          ))}
        </div>
        <div className='text-[#6A6E6E] text-[13px] font-[400] max-w-[90%]'>
          {sectionsText} <span className='font-[500]'>{metadata?.sectionAvailability?.unavailabilityReason ?? ''}</span>{' '}
        </div>
      </div>
    )

  return null
}
